import { render, staticRenderFns } from "./deviceDialog.vue?vue&type=template&id=960c51de&scoped=true&"
import script from "./deviceDialog.vue?vue&type=script&lang=ts&"
export * from "./deviceDialog.vue?vue&type=script&lang=ts&"
import style0 from "./deviceDialog.vue?vue&type=style&index=0&id=960c51de&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "960c51de",
  null
  
)

export default component.exports